"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcProgressBar = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var recharts_1 = require("recharts");
require("./arcProgressBar.css");
var BACKGROUND_FILL_COLOR = '#F2F2F2';
var polarToCartesian = function (w, h, radius, angleInDegrees) {
    var cx = w / 2;
    var cy = (h * 75) / 100;
    var angleInRadians = (angleInDegrees * Math.PI) / 180.0;
    return {
        x: cx + radius * Math.cos(angleInRadians),
        y: cy + radius * Math.sin(angleInRadians),
    };
};
var ArcProgressBar = function (_a) {
    var _b, _c;
    var height = _a.height, label = _a.label, value = _a.value, thresholds = _a.thresholds, theme = _a.theme;
    var _d = react_1.default.useState(0), width = _d[0], setWidth = _d[1];
    var chartRef = react_1.default.useRef(null);
    react_1.default.useEffect(function () {
        var updateWidth = function () {
            if (chartRef.current) {
                setWidth(chartRef.current.clientWidth);
            }
        };
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return function () {
            window.removeEventListener('resize', updateWidth);
        };
    }, [(_b = chartRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth]);
    var activeShapeColorMap = {
        nothing: '#BE411F',
        pending: '#FF9902',
        completed: '#71B62C',
        infoLight: '#16AFF0',
        infoDark: '#0E83CD',
        unknown: '#f2f2f2',
    };
    function activeShapeDefaultColorChooser() {
        if (theme) {
            return activeShapeColorMap[theme];
        }
        if (value <= 33) {
            return activeShapeColorMap.nothing;
        }
        if (value <= 66) {
            return activeShapeColorMap.pending;
        }
        return activeShapeColorMap.completed;
    }
    var renderBackground = function (p) {
        var cx = p.cx, cy = p.cy, innerRadius = p.innerRadius, outerRadius = p.outerRadius, fill = p.fill;
        return ((0, jsx_runtime_1.jsx)(recharts_1.Sector, { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: 173.5, endAngle: 6.5, fill: fill, cornerRadius: 20, cornerIsExternal: true }));
    };
    function evaluateThresholdsRadius() {
        var min = Math.min(width, height);
        if (min <= 200) {
            return 3;
        }
        if (min <= 350) {
            return 5;
        }
        return 10;
    }
    function buildThresholds() {
        return thresholds === null || thresholds === void 0 ? void 0 : thresholds.map(function (t) {
            var angle = (t / 100) * 180;
            var radius = Math.min(width, height) / 2.25;
            var _a = polarToCartesian(width, height, radius, angle - 180), x = _a.x, y = _a.y;
            return { x: x, y: y, r: evaluateThresholdsRadius() };
        });
    }
    function renderPercentageValue() {
        return ((0, jsx_runtime_1.jsx)("g", __assign({ className: "text-container-percentage" }, { children: (0, jsx_runtime_1.jsxs)("text", __assign({ className: "percentage-value", offset: 5, x: "50%", y: "70%" }, { children: [value, "%"] })) })));
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "arc-bar", ref: chartRef, style: { width: '100%', height: height } }, { children: [(0, jsx_runtime_1.jsx)(recharts_1.ResponsiveContainer, __assign({ className: "arc-bar-container" }, { children: (0, jsx_runtime_1.jsxs)(recharts_1.PieChart, __assign({ className: "arc-bar-container" }, { children: [(0, jsx_runtime_1.jsx)(recharts_1.Pie, { data: [
                                {
                                    value: 100 - value,
                                    fill: BACKGROUND_FILL_COLOR,
                                },
                                {
                                    label: label,
                                    value: Math.round(value),
                                    fill: activeShapeDefaultColorChooser(),
                                },
                            ], dataKey: "value", nameKey: "name", cx: "50%", cy: "75%", startAngle: 0, endAngle: 180, innerRadius: "80%", outerRadius: "100%", cornerRadius: 20, activeIndex: 0, activeShape: renderBackground, fill: activeShapeDefaultColorChooser(), isAnimationActive: false }), (_c = buildThresholds()) === null || _c === void 0 ? void 0 : _c.map(function (c, i) { return ((0, jsx_runtime_1.jsx)("circle", { className: "threshold-circle", cx: c.x, cy: c.y, r: c.r, fill: "white" }, "circle".concat(i))); }), renderPercentageValue()] })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-container-label" }, { children: (0, jsx_runtime_1.jsx)("p", { children: label }) }))] })));
};
exports.ArcProgressBar = ArcProgressBar;
//# sourceMappingURL=ArcProgressBar.js.map